import { createReducer } from '@reduxjs/toolkit';
import { OrganizationActions } from './actions';
import Constants from './constants';

const initialState = {
  isLoadingOrganization: false,
  editingOrganizationLoader: false,
  organizationDetailsEditMode: false,
  organizationDetails: {},
  administrators: {},
  organizationDetailsUpdateStatus: null,
  googleLoginUpdateStatus: null,
  oidcLoginUpdateStatus: null,
  updateError: null,
  shouldGetRedirectedToCreditCard: false,
  organizationIPWhitelist: {
    whitelist: [],
    enabled: false,
    loading: false,
  },
};

const ACTION_HANDLER = {
  [OrganizationActions.organizationDetailsFetch]: (state, action) => {
    state.isLoadingOrganization = true;
  },
  [OrganizationActions.organizationDetailsFetchFailed]: (state, action) => {
    state.isLoadingOrganization = false;
  },
  [OrganizationActions.editDetailsHandler]: (state, action) => {
    state.editingOrganizationLoader = true;
  },
  [OrganizationActions.toggleOrganizationEditMode]: (state) => {
    state.organizationDetailsEditMode = !state.organizationDetailsEditMode;
  },
  [OrganizationActions.organizationDetailsFetchSucceeded]: (state, action) => {
    state.organizationDetails = action.payload;
    state.isLoadingOrganization = false;
    state.updateError = null;

    if (!state.organizationDetails.address) {
      state.organizationDetailsEditMode = true;
    }
  },
  [OrganizationActions.forceGoogleLoginEnable]: (state) => {
    state.organizationDetails.enforce_google_auth = true;
  },
  [OrganizationActions.forceGoogleLoginEnableSucceeded]: (state) => {
    state.organizationDetails.enforce_google_auth = true;
  },
  [OrganizationActions.forceOidcLoginEnable]: (state) => {
    state.organizationDetails.enforce_oidc_auth = true;
  },
  [OrganizationActions.forceOidcLoginEnableSucceeded]: (state) => {
    state.organizationDetails.enforce_oidc_auth = true;
  },
  [OrganizationActions.forceGoogleLoginEnableFailed]: (state) => {
    state.googleLoginUpdateStatus = false;
  },
  [OrganizationActions.forceOidcLoginEnableFailed]: (state) => {
    state.oidcLoginUpdateStatus = false;
  },
  [OrganizationActions.forceGoogleLoginDisable]: (state) => {
    state.organizationDetails.enforce_google_auth = false;
  },
  [OrganizationActions.forceGoogleLoginDisableSucceeded]: (state) => {
    state.organizationDetails.enforce_google_auth = false;
  },
  [OrganizationActions.forceOidcLoginDisable]: (state) => {
    state.organizationDetails.enforce_oidc_auth = false;
  },
  [OrganizationActions.forceOidcLoginDisableSucceeded]: (state) => {
    state.organizationDetails.enforce_oidc_auth = false;
  },
  [OrganizationActions.forceGoogleLoginDisableFailed]: (state) => {
    state.googleLoginUpdateStatus = false;
  },
  [OrganizationActions.forceOidcLoginDisableFailed]: (state) => {
    state.oidcLoginUpdateStatus = false;
  },
  [OrganizationActions.editDetailsHandlerSucceeded]: (state, action) => {
    state.organizationDetails = action.payload;
    state.updateError = null;
    state.editingOrganizationLoader = false;
    state.organizationDetailsEditMode = false;
  },
  [OrganizationActions.editDetailsHandlerFailed]: (state, action) => {
    state.organizationDetailsUpdateStatus = false;
    state.updateError = action.payload;
    state.editingOrganizationLoader = false;
  },
  [OrganizationActions.setDetailsOnboardingSucceeded]: (state, action) => {
    state.organizationDetails = action.payload;
    state.updateError = null;
    state.editingOrganizationLoader = false;
    state.organizationDetailsEditMode = false;
  },
  [OrganizationActions.setDetailsOnboardingFailed]: (state, action) => {
    state.organizationDetailsUpdateStatus = false;
    state.updateError = action.payload;
    state.editingOrganizationLoader = false;
  },
  [OrganizationActions.redirectToCreditCard]: (state) => {
    state.shouldGetRedirectedToCreditCard = true;
  },
  [OrganizationActions.resetRedirect]: (state) => {
    state.shouldGetRedirectedToCreditCard = false;
  },
  [OrganizationActions.ipWhitelistFetch]: (state, _) => {
    state.organizationIPWhitelist.loading = true;
  },
  [OrganizationActions.ipWhitelistFetchSucceeded]: (state, action) => {
    const { enabled, whitelist } = action.payload;
    state.organizationIPWhitelist = {
      ...state.organizationIPWhitelist,
      whitelist: whitelist || [],
      enabled,
      loading: false,
    };
  },
  [OrganizationActions.ipWhitelistFetchFailed]: (state, _) => {
    state.organizationIPWhitelist.whitelist = [];
    state.organizationIPWhitelist.loading = false;
  },
};

export const organizationReducer = createReducer(initialState, ACTION_HANDLER);

export default {
  name: Constants.MODULE_NAME,
  reducer: organizationReducer,
};
